import { isNumber } from '../../../lib/util';
import type { PanZoomEvent } from './SvgMap.types';

export const checkIsPanZoomEvent = (event: Event): event is PanZoomEvent => {
  return isNumber((event as PanZoomEvent)?.detail?.x) && isNumber((event as PanZoomEvent)?.detail?.y);
};
